import { Component, OnInit, Inject } from '@angular/core';
import { Meta, Title } from '@angular/platform-browser';
import { MatDialog } from '@angular/material';
import { Router, ActivatedRoute, Params } from '@angular/router';
import { SharedService } from '../shared/shared.service';
// import { PlanDetailsService } from './esiid-flagged.service';
import { CheckAvailabilityService } from '../check-availability/check-availability.service'
import { LocalStorageService } from 'angular-2-local-storage';
import { SESSION_STORAGE, WebStorageService } from 'angular-webstorage-service';
import { FormControl, Validators, ReactiveFormsModule } from '@angular/forms';
import { FirstLetterUpperCase } from '../shared/pipe/firstletteruppercase.pipe';
import { LowerCasePipe } from '@angular/common';
import { Observable } from 'rxjs/Observable';
import { DataSource } from '@angular/cdk/collections';
import 'rxjs/add/observable/of';
import { LoggerService } from 'app/logger/logger.service';
import { PlanDetailsService } from 'app/plan-details/plan-details.service';
// global variable
declare var google;

const ZIPCODE_REGEX = /^[0-9]{5}(?:-[0-9]{4})?$/;

@Component({
  selector: 'app-esiid-flagged',
  templateUrl: './esiid-flagged.component.html',
  styleUrls: ['./esiid-flagged.component.css'],
  providers: [LowerCasePipe]
})
export class EsiIdFlaggedComponent {
 


  public hasBalanceHold: boolean;
  public hasPromotionHold: boolean;
  public hasHoldOverride: boolean;
  public hasSwitchHoldIndicator: boolean;
  public esiId: string;
 

  constructor(private meta: Meta, private title: Title, private activatedRoute: ActivatedRoute, private router: Router,
    public dialog: MatDialog, private sharedService: SharedService,private logger:LoggerService, private service: CheckAvailabilityService,
     private localStorageService: LocalStorageService, @Inject(SESSION_STORAGE) private sessionStorageService: WebStorageService, 
    private firstLetterPipe: FirstLetterUpperCase, private lowerCasePipe: LowerCasePipe) {
           
      this.hasBalanceHold = this.localStorageService.get('hasBalanceHold');
      this.hasPromotionHold = this.localStorageService.get('hasPromotionHold');
      this.hasHoldOverride = this.localStorageService.get('hasHoldOverride');
      this.esiId = this.localStorageService.get('esi_id'); 


      if (this.hasBalanceHold){
        var dataLayerEvent = 'enroll – esiid flagged – negative balance';
        (window as any).dataLayer.push({ 'event': dataLayerEvent});  
      }
      if (this.hasPromotionHold){
        var dataLayerEvent = 'enroll – esiid flagged – already received promotion';
        (window as any).dataLayer.push({ 'event': dataLayerEvent});  
      }
  } 



}



// WEBPACK FOOTER //
// ./src/app/esiid-flagged/esiid-flagged.component.ts